import { getApplicationEnrichedStatus } from '@almaris/shared/helpers/getApplicationInfo'
import { Application_Status_Enum } from '@gql'

export type GetEstateStatsProps = {
  applications?: {
    status: Application_Status_Enum
    promiseOfSaleSignatureDate?: string | null
    promiseOfSalesFileId?: string | null
    buyer_member: { visits: { id: string }[] }
    hasDraftBeenEdited: boolean
  }[]
  visits?: { isVisitDone: boolean }[]
}
export const getEstateStats = ({
  applications = [],
  visits = [],
}: GetEstateStatsProps) => {
  const { nbPlannedVisits, nbDoneVisits } = (visits ?? []).reduce(
    (acc, { isVisitDone }) => {
      if (!isVisitDone) {
        acc.nbPlannedVisits++
      }
      if (isVisitDone) {
        acc.nbDoneVisits++
      }
      return acc
    },
    { nbPlannedVisits: 0, nbDoneVisits: 0 }
  )

  const applicationEnrichedStatuses = applications.map(
    getApplicationEnrichedStatus
  )

  const { nbDrafts, nbSubmissions } = applicationEnrichedStatuses.reduce(
    (acc, applicationEnrichedStatus) => {
      if (applicationEnrichedStatus === 'Draft') {
        acc.nbDrafts++
      }
      if (
        applicationEnrichedStatus === 'Submitted' ||
        applicationEnrichedStatus === 'PreAccepted' ||
        applicationEnrichedStatus === 'UnderPromise' ||
        applicationEnrichedStatus === 'ActSigned'
      ) {
        acc.nbSubmissions++
      }
      return acc
    },
    { nbDrafts: 0, nbSubmissions: 0 }
  )

  return {
    nbPlannedVisits,
    nbDoneVisits,
    nbDrafts,
    nbSubmissions,
  }
}
